import { put, takeLatest } from "redux-saga/effects";
import { showError } from "../components/commonUtilities";
import {
    FETCH_MATCHING_BATCH_REGULATIONS,
    FetchMatchingBatchRegulationsAction,
    MatchingBatchRegulationsReceived
} from "../actions/regulation/EditBatchSelection/types";
import axios from "axios";
import { matchingBatchRegulationsReceived } from "../actions";
import { GeneratorYieldType } from "../interfaces/ActionReducer/GetMethod/GetResponse";

function* fetchMatchingBatchRegulations(
    action: FetchMatchingBatchRegulationsAction
): Generator<
    | GeneratorYieldType<MatchingBatchRegulationsReceived["payload"]>
    | Promise<MatchingBatchRegulationsReceived>,
    void,
    any
> {
    try {
        const json = yield axios.post(
            "/api/alllinks/fetch_links_on_regulations/",
            action.payload.params
        );
        yield put(matchingBatchRegulationsReceived(json.data.result));
    } catch (e) {
        showError(e);
    }
    if (action.payload.afterProcess) {
        action.payload.afterProcess();
    }
}

export function* fetchMatchingBatchRegulationsSaga() {
    yield takeLatest(FETCH_MATCHING_BATCH_REGULATIONS, fetchMatchingBatchRegulations);
}
